var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{class:['notice-queue', _vm.left ? 'notice-queue-left' : ''],attrs:{"name":"slide"}},_vm._l((_vm.notices),function(notice){return _c('notice-popup',{key:notice._id,attrs:{"notification":notice}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }